// react
import React from 'react';


// components
import Skeletonize from '../Skeletons/Skeletonize';

type Props = {
	stepsCount: number;
	currentStep: number;
	additionalClassName?: string;
	isLoading?: boolean;
	disableSkeleton?: boolean;
}


const SliderSteps: React.FC<Props> = ({stepsCount, currentStep, additionalClassName, isLoading=false, disableSkeleton=true}) => {
	return (
		<div 
			id="slider-steps"
			className={`
				grid
				gap-x-[10px]
				grid-rows-[auto]
				w-fit
				${additionalClassName}
			`}
			style={{
				gridTemplateColumns: `repeat(${stepsCount},auto)`
			}}	
		>
		{Array.from({length: stepsCount}).map((_, index) => (
			<Skeletonize
				key={index}
				isLoading={isLoading}
				disableSkeleton={disableSkeleton}
				className="w-[9px] h-[9px]"
				rounded="full"
				animation="pulse syncWave"
			>
				<div 
					key={index} 
					className={`
						w-[9px] 
						h-[9px]
						rounded-full
						bg-[#0A9281]
						animate-fade-in-up-10
						transition-opacity duration-300 ease-in-out
					`}
					style={{
						opacity: index <= currentStep ? 1 : 0.3
					}}
				>
				</div>
			</Skeletonize>
		))}
		</div>
	);
}

export default SliderSteps;
